/*
 * Opens the cookbook offer once per visitor, five seconds in.
 *
 * Not on arrival. A dialog that covers content the moment a phone finishes
 * painting is what Google classifies as an intrusive interstitial, and this
 * storefront is public, fully crawlable, and about to receive paid mobile
 * traffic. Five seconds reads as immediate to a real visitor while sitting
 * outside that pattern. The delay is one number: data-delay-ms on the
 * element in chittera-cookbook-popup.liquid — the script just reads it.
 *
 * State lives in localStorage rather than a cookie: it is never sent to the
 * server, which keeps it a functional preference rather than tracking, and it
 * survives the view transitions the theme has enabled, so the dialog does not
 * re-fire on every navigation.
 *
 * This script only ever opens a dialog. If it throws, nothing is hidden and
 * nothing is lost — the same offer sits on the homepage.
 */
(function () {
  'use strict';

  var SEEN_KEY = 'chittera:cookbook-popup-seen';
  var SUBMIT_KEY = 'chittera:cookbook-popup-submitting';
  var SUPPRESSED_PATHS = ['/cart', '/checkouts', '/account'];

  var host = document.querySelector('[data-cookbook-popup]');
  if (!host) return;

  // Never in the theme editor — an unprompted dialog makes the editor unusable.
  if (window.Shopify && window.Shopify.designMode) return;

  var path = window.location.pathname;
  for (var i = 0; i < SUPPRESSED_PATHS.length; i++) {
    if (path.indexOf(SUPPRESSED_PATHS[i]) === 0) return;
  }

  function readFlag(store, key) {
    try {
      return window[store].getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeFlag(store, key) {
    try {
      window[store].setItem(key, '1');
    } catch (e) {
      /* private mode, quota, storage disabled — the dialog just shows again */
    }
  }

  function clearFlag(store, key) {
    try {
      window[store].removeItem(key);
    } catch (e) {}
  }

  var opened = false;
  var timer = null;

  function open() {
    if (opened) return;
    opened = true;
    if (timer) clearTimeout(timer);

    customElements.whenDefined('dialog-component').then(function () {
      if (typeof host.showDialog !== 'function') return;
      host.showDialog();
      writeFlag('localStorage', SEEN_KEY);
    });
  }

  var delay = parseInt(host.getAttribute('data-delay-ms'), 10);
  if (isNaN(delay) || delay < 0) delay = 0;

  // A signup reloads the page. Reopen so the confirmation is actually seen,
  // rather than leaving it inside a dialog that is now closed.
  if (readFlag('sessionStorage', SUBMIT_KEY)) {
    clearFlag('sessionStorage', SUBMIT_KEY);
    if (host.querySelector('[data-cookbook-success]')) {
      open();
      return;
    }
  }

  if (readFlag('localStorage', SEEN_KEY)) return;

  // Dismissing counts as seen, so it does not return on the next page.
  host.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.cookbook-popup__close')) {
      writeFlag('localStorage', SEEN_KEY);
    }
  });

  var form = host.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      writeFlag('localStorage', SEEN_KEY);
      writeFlag('sessionStorage', SUBMIT_KEY);
    });
  }

  // Still a timeout at zero rather than a direct call, so opening happens in
  // its own task and never inside the parse path.
  timer = setTimeout(open, delay);
})();
